import i18n from "config/i18next";

i18n.addResources("es", "transactions", {
  transactions: "Transacciones",
  rangeExceededTitle: "El rango seleccionado es inválido",
  cancelByAdmin: "Cancelado por admin",
  cancelBySeller: "Cancelado por seller",
  rangeExceededMessage: "Por favor, ingresá un rango menor a 31 días",
  exportTooltip: `Para exportar buscá por: Cód. de trx, Nro. de orden, Id del picker, Cód. de viaje y/o Fecha`,
  masiveCancelationBody: `Seleccioná el motivo para cancelar las {{amount}} transacciones.\nYa no podrás asignarlas a un picker`,
  masiveCancelationBodySingular: `Seleccioná el motivo para cancelar la transacción.\nYa no podrás asignarla a un picker`,
  errorMasiveCancelation: `Solo se cancelaron {{amount}} transacciones.\nRevisá que las siguientes estén “Sin asignar”:`,
  errorMasiveCancelationSingular: `Solo se canceló {{amount}} transacción.\nRevisá que las siguientes estén “Sin asignar”:`,
  masiveCancelationTitle: "Cancelar transacciones",
  errorMasiveCancelationTitle: "No se pueden cancelar las transacciones",
  errorMasiveCancelationBody: `Revisá que se encuentren en estado “Sin asignar"`,
  errorMasiveCancelationTitleSingular: "No se puede cancelar la transacción",
  errorMasiveCancelationBodySingular: `Revisá que se encuentre en estado “Sin asignar"`,
  successCancelationTitle: "Transacciones canceladas",
  successCancelationTitleSingular: "Transacción cancelada",
  successCancelationBody: "Se cancelaron {{amount}} transacciones",
  successCancelationBodySingular: "Se canceló la transacción",
  someTransactionsCancelTitle: "Transacciones sin cancelar",
  resultsPerPage: "Resultados por página:",
});
